export default __webpack_public_path__ + "static/media/production-icon.640a977e.svg";